
import React, { } from "react";
import { Skeleton } from "antd";
import Container from "../../../General/Container/Container";
import { formatNumber } from "../../../../utils/MainHelper";
import CustomTable from "../../../../customcomponents/customtable/CustomTable";

function WhiteSpaceNewDisplayDetails({
    selectedItem,
    loading = true,
    list = [],
    text = "",
    style = {}
}) {
    const classColor = (() => {
        if (!selectedItem) return "black";
        const score = selectedItem.diff
        if (score > 0) return "green"
        return "red"
    })()
    return (
        <Container className="report--newWhitespace--container" style={style}>
            <Container className="drow justify-between align-start">
                {loading ? <>
                    <Skeleton.Button className="flex-1" style={{ width: "80%" }} active />
                    <Skeleton.Button style={{ width: "30mm" }} active />
                </> : <>
                    <Container className="report--newWhitespace--details--titlecont">
                        <span className={"report--newWhitespace--details--title " + classColor}>{selectedItem.title || selectedItem.name}</span>
                        <div className={"report--newWhitespace--details--divider " + classColor} ></div>
                    </Container>
                    <Container className="report--newWhitespace--details--scorecont">
                        <span className="report--newWhitespace--details--label">Size:</span>
                        <span className={"report--newWhitespace--details--score " + classColor}>{`${(formatNumber(selectedItem.diff, 2))}%`}</span>
                    </Container>
                </>
                }
            </Container> {loading ? <Skeleton paragraph={{ rows: 4 }} active /> :
                <p className="report--newWhitespace--text" style={list?.length ? {
                    height: "calc(100% - 20mm)",
                    overflowY: "auto"
                } : {}}>
                    {list?.length ? <CustomTable
                        noCheckbox
                        pagination={false}
                        columns={[
                            {
                                title: "Name",
                                key: "item"
                            },
                            {
                                title: "Score",
                                key: "score",
                                render: (value) => {
                                    return `${formatNumber((value * 100), 2)}%`
                                },
                                width: 70
                            }
                        ]}
                        numColProps={{ width: "10mm" }}
                        dataSource={list}
                        expandable={{ showExpandColumn: false }}
                        tableProps={{ showHeader: false }}
                    /> : text}
                </p>}
        </Container>
    );
}

export default WhiteSpaceNewDisplayDetails;
